import { LeftMenuItems, RouteEnum } from "../../../../models/enums";
import { LeftSideBarItem } from "../../UnifiedLayout";

export const PartnerAdminItems: LeftSideBarItem[] = [
  {
    name: LeftMenuItems.DEVICES,
    path: RouteEnum.Devices,
  },
  {
    name: LeftMenuItems.AI_MANAGER,
    path: RouteEnum.Model,
  },
  {
    name: LeftMenuItems.TELEMETRY,
    path: RouteEnum.Empty,
    showDivider: true,
    nonClickable: true,
    nestedItems: [
      {
        name: LeftMenuItems.TANK_LEVEL,
        path: RouteEnum.TelemetryTankLevel,
      },
      {
        name: LeftMenuItems.GATE_GUARD,
        path: RouteEnum.TelemetryGateGuard,
      },
      // FEATURE FLAG - PERSONNEL DETECTION. PREVENT NEW FEATURE FROM BEING ENABLED.
      // {
      //   name: LeftMenuItems.PEOPLE_AND_VEHICLE,
      //   path: RouteEnum.TelemetryPeopleAndVehicle,
      // },
      {
        name: LeftMenuItems.HARD_HAT,
        path: RouteEnum.TelemetryHardHat,
      },
    ],
  },
  {
    name: LeftMenuItems.CUSTOMER_SETTINGS,
    path: RouteEnum.CustomerSettings,
    isSeparatorOfBottomSection: true,
  },
  {
    name: LeftMenuItems.CONTROL_ROOM_BETA,
    path: RouteEnum.ControlRoom,
    showDivider: true,
  },
  {
    name: LeftMenuItems.RECENT_ACTIVITIES,
    path: RouteEnum.RecentActivities,
    showDivider: true,
  },

  {
    name: LeftMenuItems.LIVE_VIEW,
    path: RouteEnum.LiveView,
  },
  {
    name: LeftMenuItems.DEPLOYMENT_HEALTH,
    path: RouteEnum.DeploymentHealth,
  },
  {
    name: LeftMenuItems.STATISTICS,
    path: RouteEnum.Statistics,
  },
  {
    name: LeftMenuItems.SYSTEM_SETTINGS,
    path: RouteEnum.SystemSettings,
    showDivider: true,
  },
];
